import { render, staticRenderFns } from "./AdPreviewCard.vue?vue&type=template&id=1b85a150&"
import script from "./AdPreviewCard.vue?vue&type=script&lang=js&"
export * from "./AdPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./AdPreviewCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports